export const MainPrivateView = '/voivodeship';
export const SuccessMessageTimeout = 2000;
